import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useFocusedConversation = (): IGlobalStore['focused_conversation'] => {
  return useSelector((store: IReducerStore) => store.global.focused_conversation);
};
